import React, { Fragment }from 'react'
import i18n from '../../../../i18n'
import '../KeyMetrics.css'
import { useSelector } from 'react-redux'
import HoldingsRow from './HoldingsRow'
import { GenTableLoading } from '../../Components/Spinner'
import ReactTooltip from 'react-tooltip'

const TopHoldings = () => {
  let data = useSelector(state => state.fundData.data)
  let asOfDate = null

  const topHoldings = data.filter(x => x.topHoldings !== null);
  const hasTopHoldings = topHoldings.length > 0     
  
  const funds = data.filter(x => x.assetClass !== 'Fixed Income')
  const loadingPerformanceData = useSelector(state => state.fundData.loadingPerformanceData)
  const loadingConstituents = useSelector(state => state.fundData.loadingConstituents)
  const errorConstituents = useSelector(state => state.fundData.errorConstituents)

  const RenderHeader = () => {

    if (!loadingPerformanceData && data[0].stdPerformanceMonthly) {
      asOfDate = new Date(data[0].stdPerformanceMonthly[0].asOfDate).toLocaleDateString()
    }

    if (funds.length >= 1) {
      const tickerList = funds.map((fund, idx) => {
        const borderStyle = idx !== 0 ? 'holdingsBorderleft' : ''
        if (fund.topHoldings) {
          return (
            <th key={fund.ticker} colSpan='2' className={`${borderStyle} borderbottom textLeft`}>
                {fund.type === 'BMK' || fund.type === 'BLEND' ? (
                  <>
                    <span  data-tip data-for={`_top_holdings_header`}>
                      {fund.ticker.toUpperCase()}
                    </span> 
                    <ReactTooltip
                      key={`_top_holdings_header`}
                      id={`_top_holdings_header`}
                      type='light'
                      textColor='#5b6770'
                      arrowColor='transparent'
                      effect='float'
                    >
                    {fund.name}
                    </ReactTooltip> 
                   </> 

                ) : fund.fundPageURL ? (
                  <a className='tickerLinkFC' href={fund.fundPageURL} target='_new'>
                    {fund.ticker}
                  </a>
                ) : (
                  <a className='tickerLinkFC' href={fund.msUrl} target='_new'>
                    {fund.ticker}
                  </a>
                )}                              
            </th>    


 
          )
        } else {
          return null
        }
      })

      return (
        <Fragment>
          <tr>
            <th colSpan={tickerList.length * 2} className='textLeft'>
              {i18n.t('top ten holdings').toUpperCase()} {i18n.t('as of')} {asOfDate}{' '}
            </th>
          </tr>
          <tr>{tickerList}</tr>
        </Fragment>
      )
    } else {
      return null
    }
  }  
  
  const RenderRows = () => {

    if (!hasTopHoldings) {
      return null
    }

    const tickers = data.map(a => a.ticker)
    if (data.length > 0) {
      const haveHoldings = []

      data.map(fund => {
        if (fund.topHoldings) {
          const { keys, values } = fund.topHoldings
          const constitutents = keys.map((name, i) => ({
            name,
            weight: values[i]
          }))
          haveHoldings.push(constitutents)
          return constitutents
        } else {
          return null
        }
      })

      let elements = Array.from(Array(10).keys(), n => n)
      return (
        <Fragment>
          {elements.map((value, index) => {
            return <HoldingsRow key={index} fundRows={haveHoldings} idx={index} type={'dataRow'} tickers={tickers}></HoldingsRow>
          })}
        </Fragment>
      )
    } else {
      return null
    }
  }

  if (errorConstituents) {
    return null
  }  

  if (!loadingConstituents && !hasTopHoldings) {
    return null
  }

  if (loadingConstituents && !hasTopHoldings) {
    return <GenTableLoading message={"Gathering Overlaps and Correlations"} />
  }

  return(
    <div className='col-12 table-responsive' style={{ paddingRight: '0px', marginBottom: '65px', paddingLeft: '0px' }}>
      <table className='table tableHR'>
      <thead>{RenderHeader()}</thead>
      <tbody>{RenderRows()}</tbody>
    </table>
  </div>    
  )
}

export default TopHoldings